import styled from "styled-components";
import breakpoints from "../../../../styles/breakpoints";
import colors from "../../../../styles/colors";
import { SectionTitle } from "../common/Charts.styles";

export const UnitsAnalyticsGridContainer = styled.div`
  display: block;
  margin-left: 0.5rem;
`;

export const GridHeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 20% 40% 40%;
  grid-gap: 1rem;
  padding: 1rem;
`;

export const QuestionAnalyticsHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
`;

export const ExercisesSectionTitle = styled(SectionTitle as any)`
  font-size: 1.5rem;
  flex-basis: 10%;

  @media (${({ theme }) => theme.breakpoints.min800}) {
    font-size: 1.17em;
    flex-basis: 18%;
  }
`;

export const QuestionsSectionTitle = styled(SectionTitle as any)`
  gap: 0.75rem;
  font-size: 1.5rem;
  flex-basis: 10%;

  > svg {
    flex-shrink: 0;
  }

  @media (${({ theme }) => theme.breakpoints.min800}) {
    font-size: 1.17em;
    flex-basis: 18%;
  }
`;

export const TotalResponsesHeader = styled.h3`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-basis: 9%;
  font-size: 1.2rem;
  font-weight: 400;
  padding: 1rem 0 0;

  @media (${({ theme }) => theme.breakpoints.min800}) {
    font-size: 16px;
  }
`;
export const GridHeaderTitle = styled.h3`
  text-align: center;
`;

export const GridContentContainer = styled.div`
  display: block;
  width: auto;
`;

export const UnitContainer = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;

  :hover {
    background-color: ${colors.chartLightGreyHighlight50};
  }
`;

export const UnitChartGridContainer = styled.div`
  display: grid;
  grid-template-columns: 20% 40% 40%;
  width: 100%;
  grid-gap: 1rem;
  padding: 1rem;
`;

export const UnitChartsNameContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const UnitName = styled.h4`
  text-align: left;
  width: 100%;
`;

export const IndividualUnitChartContainer = styled.div<{ isFirst: boolean }>`
  div {
    height: 150px;
  }

  @media (${breakpoints.min800}) {
    display: flex;
    justify-content: center;
    align-items: center;

    div {
      height: ${props => (props.isFirst ? "10vw" : "8vw")};
    }
  }
`;
